import { useState } from 'react';
import { useNotification } from './useNotification';
import apiService from '../services/api';

const useHealthZonesCrud = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showNotification } = useNotification();

  const addHealthZone = async (healthZoneData) => {
    setIsLoading(true);
    try {
      console.log('Ajout de la zone de santé:', healthZoneData);
      const response = await apiService.createHealthZone(healthZoneData);
      console.log('Réponse API:', response);
      showNotification('Zone de santé ajoutée avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de l\'ajout de la zone de santé:', error);
      showNotification(`Erreur lors de l'ajout de la zone de santé: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const updateHealthZone = async (healthZoneId, healthZoneData) => {
    setIsLoading(true);
    try {
      console.log('Mise à jour de la zone de santé:', healthZoneId, healthZoneData);
      const response = await apiService.updateHealthZone(healthZoneId, healthZoneData);
      console.log('Réponse API:', response);
      showNotification('Zone de santé modifiée avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la modification de la zone de santé:', error);
      showNotification(`Erreur lors de la modification de la zone de santé: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const deleteHealthZone = async (healthZoneId) => {
    setIsLoading(true);
    try {
      console.log('Suppression de la zone de santé:', healthZoneId);
      const response = await apiService.deleteHealthZone(healthZoneId);
      console.log('Réponse API:', response);
      showNotification('Zone de santé supprimée avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la suppression de la zone de santé:', error);
      showNotification(`Erreur lors de la suppression de la zone de santé: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addHealthZone,
    updateHealthZone,
    deleteHealthZone,
    isLoading
  };
};

export default useHealthZonesCrud;
